import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from 'src/app/services/common/api-service.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-merchant-subscription',
  templateUrl: './merchant-subscription.component.html',
  styleUrls: ['./merchant-subscription.component.scss']
})
export class MerchantSubscriptionComponent implements OnInit {

  merchantData: any;
  currentTier: string = 'STANDARD';
  loading: boolean = false;
  merchantPlans: any[] = [];

  constructor(
    private apiService: ApiServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const merchantId = localStorage.getItem('merchantId');
    if (merchantId) {
      this.apiService.getMerchantProfile(merchantId).subscribe({
        next: (res: any) => {
          this.merchantData = res.data;
          this.currentTier = this.merchantData.subscriptionTier || 'STANDARD';
        },
        error: (err) => {
          console.error("Failed to load merchant profile", err);
        }
      });
    }
    
    this.apiService.getMerchantPlans().subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.merchantPlans = res.data;
        }
      },
      error: (err) => console.error("Failed to fetch merchant plans", err)
    });
  }

  loadRazorpaySDK(): Promise<boolean> {
    return new Promise((resolve) => {
      if ((window as any).Razorpay) {
        return resolve(true);
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  }

  async upgradeToPremium() {
    if (!this.merchantData?._id) return;
    
    const premiumPlan = this.merchantPlans.find(p => p.planName?.toUpperCase() === 'PREMIUM');
    const amount = premiumPlan ? premiumPlan.price : 999;

    Swal.fire({
      title: 'Initializing Checkout...',
      text: 'Connecting to Razorpay secure gateway...',
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading(); }
    });

    const isSdkLoaded = await this.loadRazorpaySDK();
    if (!isSdkLoaded) {
      Swal.fire('Error', 'Razorpay SDK failed to load. Are you online?', 'error');
      return;
    }

    this.apiService.createRazorpayOrder(amount).subscribe({
      next: (orderRes: any) => {
        Swal.close();
        if (!orderRes || orderRes.status !== 'success') {
          Swal.fire('Checkout Error', orderRes?.message || 'Could not initiate transaction', 'error');
          return;
        }

        const orderData = orderRes.data;
        const options = {
          key: 'rzp_test_T6EoWzlfgAKmNv',
          amount: orderData.amount,
          currency: orderData.currency || 'INR',
          name: 'Weddingly Merchant',
          description: `Premium Subscription Upgrade`,
          order_id: orderData.orderId,
          handler: (response: any) => {
            Swal.fire({
              title: 'Verifying Signature...',
              text: 'Cryptographic validation in progress...',
              allowOutsideClick: false,
              didOpen: () => { Swal.showLoading(); }
            });

            this.apiService.upgradeSubscription(this.merchantData._id, {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature
            }).subscribe({
              next: (res: any) => {
                this.loading = false;
                Swal.fire('Success', 'Successfully upgraded to Premium Plan!', 'success');
                this.merchantData = res.data;
                this.currentTier = res.data.subscriptionTier;
              },
              error: (err) => {
                this.loading = false;
                Swal.fire('Error', err.error?.message || 'Failed to verify payment and upgrade plan', 'error');
              }
            });
          },
          prefill: {
            name: this.merchantData.owner_name,
            email: this.merchantData.email,
            contact: this.merchantData.phone
          },
          theme: {
            color: '#B01E3E'
          }
        };

        const rzp = new (window as any).Razorpay(options);
        rzp.open();
      },
      error: (err) => {
        Swal.fire('Order Creation Failed', err.error?.message || 'Server error communicating with payment gateway.', 'error');
      }
    });
  }
}
